import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import useStyles from './style'

function Checkbox({
  id,
  name,
  title,
  titleColor,
  titleClassName,
  checked = false,
  onCheck,
  className,
  classContainer,
  readOnly,
  isLarge = false,
  isBoldTitle = true,
  centerVertically,
  // partially checked is just UI state (dash in the middle) for unchecked checkbox
  // currently used on MultiLevelSelect to indicate that child to current checkbox is checked
  isPartiallyChecked,
  disabled,
  children
}) {
  const classes = useStyles({
    isLarge,
    isBoldTitle,
    isPartiallyChecked,
    // if isPartiallyChecked > center by default
    centerVertically: centerVertically || isPartiallyChecked,
    titleColor,
    disabled
  })

  const onChangeHandler = e => {
    if (!disabled && onCheck) {
      onCheck(e)
    }
  }

  return (
    <div className={classContainer}>
      <div className={classnames('checkbox', classes.checkbox, className)}>
        <input
          className={classes.checkboxInput}
          type="checkbox"
          id={id}
          onChange={onChangeHandler}
          checked={checked}
          readOnly={readOnly}
          name={name}
          disabled={disabled}
        />
        <label className={classes.checkboxLabel} htmlFor={id}>
          {title && <div className={classnames(classes.checkboxTitle, titleClassName)}>{title}</div>}
          {children && <div className={classes.checkboxBody}>{children}</div>}
        </label>
      </div>
    </div>
  )
}

Checkbox.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  name: PropTypes.string,
  checked: PropTypes.bool,
  onCheck: PropTypes.func.isRequired,
  title: PropTypes.string,
  titleColor: PropTypes.string,
  titleClassName: PropTypes.string,
  className: PropTypes.string,
  classContainer: PropTypes.string,
  excerpt: PropTypes.instanceOf(Element),
  isLarge: PropTypes.bool,
  isBoldTitle: PropTypes.bool,
  centerVertically: PropTypes.bool,
  isPartiallyChecked: PropTypes.bool
}

export default Checkbox
